module.exports = __webpack_public_path__ + "static/media/antes50mg.c1ff0c40.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-alambrico/antes50mg.png
// module id = 100
// module chunks = 0